import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { BarChart3, Users, Layers, Package, Gift, Store, MessageSquare, ShoppingBag } from "lucide-react";

function Stat({ icon: Icon, label, value, accent }) {
  return (
    <div className="hud-pill rounded-2xl p-5 relative overflow-hidden">
      <Icon className={`h-5 w-5 ${accent}`} />
      <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/40 mt-3">{label}</div>
      <div className="font-display text-4xl text-white mt-1">{value ?? "—"}</div>
    </div>
  );
}

export default function AdminStats() {
  const { data } = useQuery({ queryKey: ["admin-stats"], queryFn: async () => (await api.get("/admin/stats")).data });
  return (
    <div>
      <h1 className="font-display text-3xl text-white tracking-[0.06em] mb-6">VAULT OVERVIEW</h1>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Stat icon={Users} label="Users" value={data?.users} accent="text-cyan-300" />
        <Stat icon={Layers} label="Templates" value={data?.templates} accent="text-emerald-300" />
        <Stat icon={ShoppingBag} label="Cards Minted" value={data?.cards_minted} accent="text-amber-300" />
        <Stat icon={Package} label="Packs" value={data?.packs} accent="text-violet-300" />
        <Stat icon={Gift} label="Codes" value={data?.codes} accent="text-cyan-300" />
        <Stat icon={Store} label="Active Listings" value={data?.listings} accent="text-emerald-300" />
        <Stat icon={MessageSquare} label="Pending Requests" value={data?.pending_requests} accent="text-amber-300" />
        <Stat icon={MessageSquare} label="Pending Trades" value={data?.pending_trades} accent="text-violet-300" />
      </div>
    </div>
  );
}
